import * as React from 'react'

import { observer } from 'mobx-react'

import BaseGroupingOptions from '~/client/src/desktop/components/BaseGroupingOptions/BaseGroupingOptions'

import LogisticsGroupingOptionsStore from './LogisticsGroupingOptions.store'

// localization: no display text to translate

interface IProps {
  store: LogisticsGroupingOptionsStore
  forceClose: boolean
}

@observer
export default class LogisticsGroupingOptions extends React.Component<IProps> {
  public constructor(props: IProps) {
    super(props)
  }

  public render() {
    const { forceClose, store } = this.props

    return (
      <BaseGroupingOptions
        store={store}
        forceClose={forceClose}
        shouldHideBandCreation
      />
    )
  }
}
